import { styled } from '@mui/material';
import type { UIDefinitionStyles } from '../../../../utils/styles';

export const RecordValueItemWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.5rem',
  flexWrap: 'wrap',
  width: '100%',
}));

export const RecordValueItemSpan = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isCursorPointer' && prop !== 'uiDefinitionStyles',
})<{ isCursorPointer?: boolean; uiDefinitionStyles?: UIDefinitionStyles }>(({ isCursorPointer, uiDefinitionStyles, theme }) => ({
  cursor: isCursorPointer ? 'pointer' : 'default',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'wrap',
  display: 'block',
  width: '100%',
  backgroundColor: theme.palette.secondary.light,
  borderRadius: '6px',
  fontSize: '12px',
  ...uiDefinitionStyles,
  [theme.breakpoints.down('md')]: {
    padding: '2px 4px',
  },
}));
